import React from "react";
import useViewerContext from "./use-viewer-context.ts";
import SimpleLoadingIndicator from "@/components/simple-loading-indicator";
import ViewerError from "@/components/viewer-error";

export interface ViewerCanvasProps {
    className?: string;
    showLoading?: boolean;
    loadingText?: string;
    children?: React.ReactNode;
}

export const ViewerCanvas: React.FC<ViewerCanvasProps> = ({
    className = "w-full h-full overflow-hidden",
    showLoading = true,
    loadingText = "Chargement de la 3D...",
    children,
}) => {
    const { setContainer, isLoading, error, retry } = useViewerContext();

    return (
        <div className="relative w-full h-full">
            <div ref={setContainer} className={className} />
            {showLoading && isLoading && (
                <div className="absolute inset-0 flex items-center justify-center bg-black/10 z-10 pointer-events-none">
                    <SimpleLoadingIndicator text={loadingText} className="m-auto" />
                </div>
            )}
            {children}
            <ViewerError error={error} retry={retry} />
        </div>
    );
};

export default ViewerCanvas;
